import $apiJSON from '../http/apiJSON'

// IT Services API

export async function getITCategories(params = {}) {
  return $apiJSON.get('it/categories/', { params })
}

export async function getITServices(params = {}) {
  return $apiJSON.get('it/services/', { params })
}

export async function getITService(slug) {
  return $apiJSON.get(`it/services/${slug}/`)
}

export async function createServiceRequest(slug, data) {
  return $apiJSON.post(`it/services/${slug}/request/`, data)
}

export async function getServiceRequests() {
  return $apiJSON.get('it/requests/')
}

export async function getServiceRequest(id) {
  return $apiJSON.get(`it/requests/${id}/`)
}

export async function cancelServiceRequest(id) {
  return $apiJSON.post(`it/requests/${id}/cancel/`)
}

export async function addServiceReview(slug, data) {
  return $apiJSON.post(`it/services/${slug}/reviews/`, data)
}

export async function getITStats() {
  return $apiJSON.get('it/stats/')
}

export async function getITProjects(params = {}) {
  // Placeholder - backend doesn't have projects endpoint yet
  return { data: { results: [], total_pages: 1 } }
}

export async function orderITService(serviceId, orderData) {
  // Use existing createServiceRequest function
  return createServiceRequest(serviceId, orderData)
}

export async function createITProject(projectData) {
  // Placeholder - backend doesn't have projects endpoint yet
  console.warn('createITProject: Projects endpoint not implemented yet')
  return { data: { message: 'Project request sent (placeholder)' } }
}